import { render, staticRenderFns } from "./quesGuide10.vue?vue&type=template&id=180e900a"
import script from "./quesGuide10.vue?vue&type=script&lang=js"
export * from "./quesGuide10.vue?vue&type=script&lang=js"
import style0 from "./quesGuide10.vue?vue&type=style&index=0&id=180e900a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports